import { useEffect, useState, useCallback } from 'react';
import api from 'api';
import { BurnCenterType } from 'types/burnCenter';

const useBurnCenter = (id: string | number) => {
  const [burnCenter, setBurnCenter] = useState<BurnCenterType | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const fetchBurnCenter = useCallback(async () => {
    if (id === null || id === undefined || id === '') return;
    try {
      setLoading(true);
      setError(null);
      const response = await api.getBurnCenterById(id);
      setBurnCenter(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchBurnCenter();
  }, [fetchBurnCenter]);

  return {
    burnCenter, loading, error, refetch: fetchBurnCenter,
  };
};

export default useBurnCenter;
